import { render, staticRenderFns } from "./SettingsScreen.vue?vue&type=template&id=4c3a6cd6&"
import script from "./SettingsScreen.vue?vue&type=script&lang=js&"
export * from "./SettingsScreen.vue?vue&type=script&lang=js&"
import style0 from "./SettingsScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports